<template>
  <div>
    <full-page :options="options">
      <!-- 一 -->
      <div class="section">
        <heade ref="secHeight"></heade>
        <div class="industryBox">
          <el-carousel
            :interval="10000"
            :autoplay="true"
            :height="bannderHeight"
            arrow="never"
          >
            <el-carousel-item v-for="(item, index) in carous" :key="index">
              <div class="banndeImg">
                <img :src="item.banner_image" alt="" />
              </div>
              <div class="down">
                <div>
                  <div class="downText">
                    {{ item.title }}
                    <!-- <span>VX.0</span> -->
                  </div>
                  <div class="downTwo">
                    <img src="../assets/homeview/textLeft.png" alt="" />
                    <div class="downCenter">{{ item.sub_title }}</div>
                    <img src="../assets/homeview/textRight.png" alt="" />
                  </div>
                  <div class="look" @click="api(index)" v-if="!index == 0">
                    <span>查看详情</span>
                    <img src="../assets/homeview/arrow.png" alt="" />
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="industry" ref="industryBox">
          <div class="level">
            <div class="levelTitle">平台发展水平</div>
            <div class="levRight">
              <!-- <div class="levelLook" @click="levelClick()">
                <div class="levelTop">查看数据</div>
                <img src="../assets/homeview/vector.png" alt="" />
              </div> -->
            </div>
          </div>
          <div class="model">
            <div class="modelLeft" v-for="(item, index) in arr" :key="index">
              <div class="modelImg">
                <img :src="item.imgUrl" alt="" />
              </div>
              <div class="modelRight">
                <div class="modelTitle">{{ item.name }}</div>
                <div class="modelText">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 二 -->
      <div class="section">
        <heade ref="secHeight"></heade>
        <div class="slate">
          <div class="slateTitle">{{ companyTitle }}</div>
          <span></span>
        </div>
        <div class="generation">
          <div class="generLeft">
            <div class="generTitle">{{ companyTitle }}</div>
            <div class="generText">
              <div style="text-indent: 0.2rem">{{ companyText }}</div>
              <br />
              <div style="text-indent: 0.2rem">{{ companySub }}</div>
            </div>
            <div class="generLook" @click="generClick()">
              <span>更多“关于赛意”</span>
              <img src="../assets/homeview/arrow.png" alt="" />
            </div>
          </div>
          <div class="generRight">
            <video
              muted
              autoplay="autoplay"
              loop="loop"
              width="100%"
              height="100%"
              controls
              :src="companyVideo"
            ></video>
          </div>
        </div>
      </div>
      <!-- 三 -->
      <div class="section">
        <heade ref="secHeight"></heade>
        <div class="newBox">
          <div class="newTitle">最新资讯</div>
          <span class="newLine"></span>
          <div class="new">
            <div class="newLeft">
              <div
                class="newImg"
                v-for="(item, index) in newImg"
                :key="index"
                v-show="index == num"
              >
                <img :src="item.image" alt="" />
              </div>
            </div>
            <div class="newRight">
              <div
                class="newTop"
                v-for="(item, index) in news"
                :key="index"
                @mouseover="change(index)"
                :class="{ active: index == num }"
              >
                <div class="topLeft">
                  <div class="day">{{ item.title }}</div>
                  <div class="newText">
                    <span>{{ item.author }}</span
                    ><span class="time">{{ item.adddate }}</span>
                  </div>
                </div>
                <div class="topRight">
                  <img :src="item.image" alt="" />
                </div>
                <div class="topx">
                  <div class="topRights" @click="detailClick(item)">
                    <div class="topLook">查看详情</div>
                    <img src="../assets/homeview/redarrow.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 四 -->
      <div class="section">
        <heade ref="secHeight"></heade>
        <div class="parity">
          <div class="parityTitle">平台业务架构</div>
          <div class="parityLine"></div>
          <div class="parityImg">
            <img :src="parity" alt="" />
          </div>
        </div>
      </div>
      <!-- 五 -->
      <div class="section">
        <heade ref="secHeight"></heade>
        <div class="productBox">
          <div class="productTitle">产品中心</div>
          <div class="productLine"></div>
          <div class="IntelBox">
            <div class="Intel" v-for="(item, index) in Intel" :key="index">
              <div class="intelP">
                <img :src="item.image2" alt="" />
                <div class="intelA">
                  <div class="intelTitle">{{ item.nickname }}</div>
                  <div class="intelLine"></div>
                  <div
                    class="intelText"
                    v-for="(items, indexArr) in Intel[index].list
                      ? Intel[index].list.slice(0, 10)
                      : []"
                    :key="indexArr"
                    @click="intelClick(items)"
                  >
                    {{ items.title }}
                  </div>
                  <div
                    class="ellipsis"
                    style="
                      color: #ffffff;
                      font-size: 0.16rem;
                      padding: 0.06rem 0 0 0.4rem;
                    "
                    v-if="Intel[index].list ? Intel[index].list.length > 10 : 0"
                  >
                    ...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 六 -->
      <div class="section">
        <heade ref="secHeight"></heade>
        <div class="planBox">
          <div class="planTitle">方案中心</div>
          <div class="planLine"></div>
          <div class="sector">
            <div class="Dtrade">
              <div
                class="trade"
                v-for="(item1, index) in trade1"
                :key="index"
                @click="tradeClick(item1)"
              >
                <!-- <div class="red" style="">行业解决方案</div> -->
                <img :src="item1.icon_image" alt="" />
                <div class="tradeText">{{ item1.title }}</div>
              </div>

              <div
                class="trade"
                v-for="item2 in trade2"
                :key="item2.id"
                @click="tradeClick(item2)"
              >
                <!-- <div class="red" style="">产业解决方案</div> -->

                <img :src="item2.icon_image" alt="" />
                <div class="tradeText">{{ item2.title }}</div>
              </div>
              <div
                class="trade"
                v-for="item3 in trade3"
                :key="item3.id"
                @click="tradeClick(item3)"
              >
                <!-- <div class="red" style="">领域解决方案</div> -->

                <img :src="item3.icon_image" alt="" />
                <div class="tradeText">{{ item3.title }}</div>
              </div>
            </div>
            <!-- <div class="sectorLeft">
              <div
                class="sectorTory"
                v-for="(item, index) in trade"
                :key="index"
                @mouseover="sector(index)"
                :class="{ actived: index == pop }"
              >
                <span>{{ item.nickname }}</span>
                <i class="iconfont">&#xe69a;</i>
              </div>
            </div>
            <div class="sectorRight" v-if="trade.length">
              <div class="sector">
                
                  <div
                    class="trade"
                    v-for="(items, index) in trade[pop].list"
                    :key="index"
                    @click="tradeClick(items)"
                  >
                    <img :src="items.icon_image" alt="" />
                    <div class="tradeText">{{ items.title }}</div>
                  </div>
                  <div
                    class="trade"
                    v-for="(itemss, index) in 24-trade[pop].list.length"
                    :key="index"

                  >
                    
                  </div>
                
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- 七 -->
      <div class="section">
        <heade ref="secHeight"></heade>
        <div class="surveyBox">
          <div class="surveyTitle">标杆案例</div>
          <div class="surveyLine"></div>
          <div class="survey">
            <div
              class="surveyImg"
              v-for="(item, index) in surveyImg"
              :key="index"
            >
              <img :src="item.image" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- foot -->
      <div class="section fp-auto-height">
        <foot></foot>
      </div>
    </full-page>
  </div>
</template>

<script>
import heade from "../components/header.vue";
import foot from "../components/footer.vue";
import model1 from "../assets/homeview/model1.png";
import model2 from "../assets/homeview/model2.png";
import model3 from "../assets/homeview/model3.png";
export default {
  name: "",
  data() {
    return {
      // fullpage
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        scrollOverflow: true,
        menu: "#menu",
        fitToSection: true,
        navigation: true,
        navigationPosition: "right",
        navigationTooltips: [],
        showActiveTooltip: true, //是否显示当前页面的tooltip信息
        verticalCentered: true, //垂直居中
        slidesNavigation: true,
        afterLoad: this.afterLoad,
        // anchors: ["page1","page2","page3"],
        // lockAnchors: true,
      },
      // banner轮播
      carous: {},
      // 平台发展水平
      model: {},
      model1,
      model2,
      model3,
      arr: [],
      // 最新资讯
      num: 1,
      newImg: [],
      news: [],
      // 第二屏
      companyTitle: "",
      companySub: "",
      companyText: "",
      companyVideo: "",
      // 平台业务架构
      parity: "",
      // 产品中心
      Intel: [],
      intelArr: [],
      pop: 0,
      tory: [],
      trade1: [],
      trade2: [],
      trade3: [],

      // 标杆案例
      surveyImg: [],
      bannderHeight: "",
      wutrade: "",
      // 获取浏览器域名
      test: "",
      cs: "",
    };
  },
  mounted() {
    // 获取浏览器域名
    this.test = window.location.href;
    console.log(this.test);
    // 获取页面的高（去除留白）
    const secHeight = this.$refs.secHeight.$el.offsetHeight;
    this.bannderHeight =
      window.innerHeight -
      this.$refs.industryBox.offsetHeight -
      secHeight +
      "px";
    this.getIndex();
    if (this._isMobile()) {
      console.log("我是手机");
      this.$router.push({
        path: "./phoneIndex",
      });
    } else {
      console.log("我是pc");
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 最新资讯
    change(index) {
      this.num = index;
    },
    // 方案中心
    sector(index) {
      this.pop = index;
    },
    // banner跳转（查看更多）
    api(index) {
      if (index == 1) {
        // 取出本地数据头像姓名token，先验证token
        console.log(JSON.parse(localStorage.getItem("token")));
        if (JSON.parse(localStorage.getItem("token")) != null) {
          // 本地有token
          // 使用全局方法验证token
          this.$fun.detetoken();
          // 全局方法拿到内网token
          var account = JSON.parse(localStorage.getItem("account"));
          var password = JSON.parse(localStorage.getItem("password"));
          var token = JSON.parse(localStorage.getItem("token"));
          console.log(account, password, token);
          // window.open(
          //   "http://iidp.chinasie.com/iidp/zxqyfwpt?token=" +  token,"_blank");
          // 全局跳转内网控制台
          this.$fun.controll();
          return;
        } else {
          // 否则没登陆需跳转到登录页
          this.open3();
          this.loginjump();
        }
        this.loginjump();
      } else if (index == 2) {
        // window.open("this.test+'/#/productInfo?id=22'", "_blank");
        let routeData = this.$router.resolve({
          path: 'productInfo?id=22',
        });
        //必要操作，否则不会打开新页面
        window.open(routeData.href, "_blank");
      }
    },
    open3() {
      this.$message({
        message: "请先登录",
        type: "warning",
      });
    },
    // 跳转到login页面
    loginjump() {
      this.$router.push({
        path: "/login",
      });
    },
    levelClick() {
      // window.open(
      //   "http://iidp.chinasie.com/iidp/?pageId=chart-runpage&id=02re4vdjyw8ao",
      //   "_blank"
      // );
      if (JSON.parse(localStorage.getItem("token")) != null) {
        // 本地有token
        // 使用全局方法验证token
        this.$fun.detetoken();
        // 全局方法拿到内网token
        var account = JSON.parse(localStorage.getItem("account"));
        var password = JSON.parse(localStorage.getItem("password"));
        var token = JSON.parse(localStorage.getItem("token"));
        console.log(account, password, token);

        this.$fun.shuzi();
        return;
      } else {
        // 否则没登陆需跳转到登录页
        this.open3();
        this.loginjump();
      }
    },
    // 新闻查看详情
    detailClick(item) {
      window.open(item.url, "_blank");
    },
    // 首页接口
    getIndex() {
      this.$http({
        url: "/index/index", //请求的后台接口
        method: "get", //get请求方式
      }).then(({ data }) => {
        console.log(data);
        // 轮播图
        this.carous = data.data.banner;
        // banner下方文字
        this.model = data.data.banner_footer;
        for (let key in this.model) {
          this.arr.push({ name: key, value: this.model[key] });
        }
        this.arr.map((item, index) => {
          if (index == 0) {
            item.imgUrl = this.model1;
          } else if (index == 1) {
            item.imgUrl = this.model2;
          } else if (index == 2) {
            item.imgUrl = this.model3;
          }
        });
        // 第二屏
        this.companyTitle = data.data.company_title;
        this.companySub = data.data.company_subtitle;
        this.companyText = data.data.company_text;
        this.companyVideo = data.data.company_video;
        // 最新资讯
        this.newImg = data.data.news;
        this.news = data.data.news;
        // 平台业务架构
        this.parity = data.data.framework;
        // 产品中心
        this.Intel = data.data.product;
        // 方案中心
        // this.tory = data.data.plan;
        this.trade1 = data.data.plan[0].list;
        console.log(data.data.plan);
        this.trade2 = data.data.plan[1].list;
        this.trade3 = data.data.plan[2].list;

        // 标杆案例
        this.surveyImg = data.data.logos;
      });
    },
    // 第二屏幕跳转
    generClick() {
      this.$router.push({
        path: "/about",
      });
    },
    // 产品中心跳转
    intelClick(items) {
      this.$router.push({
        path: items.html_enum == "a" ? "/productInfo" : "/productTwo",
        query: { id: items.id },
      });
    },
    // 方案中心跳转
    tradeClick(items) {
      this.$router.push({
        path: "/scheme_article",
        query: { id: items.id },
      });
    },
  },
  components: {
    heade,
    foot,
  },
};
</script>

<style scoped lang="scss">
::v-deep  .fp-scroller {
  height: 100%;
}
span {
  display: inline-block;
}

// 一
.industryBox {
  position: relative;

  .banndeImg {
    display: flex;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .down {
    position: absolute;
    top: 2.4rem;
    left: 0;
    color: #fff;
    width: 100%;

    .downText {
      text-align: center;
      font-size: 0.48rem;
      font-weight: 900;

      span {
        font-weight: 250;
        padding-left: 0.06rem;
      }
    }

    .downTwo {
      font-size: 0.24rem;
      font-weight: 300;
      text-align: center;
      padding-top: 0.48rem;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 0.32rem;
        height: 0.02rem;
      }

      .downCenter {
        padding: 0 0.2rem;
      }
    }

    .look {
      background: #cf094b;
      border-radius: 0.12rem 0;
      width: 1.52rem;
      height: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0.96rem auto 0;
      cursor: pointer;

      span {
        color: #ffffff;
        font-size: 0.18rem;
        font-weight: 400;
        display: block;
      }

      img {
        width: 0.08rem;
        height: 0.12rem;
        margin-left: 0.08rem;
      }
    }
  }
}

.industry {
  display: flex;

  .level {
    width: 40%;
    // padding: 0.18rem 0;
    background: #cf094b;
    height: 1.19rem;
    line-height: 1.19rem;

    .levRight {
      padding-right: 2.02rem;
      display: flex;
      justify-content: end;
      margin-top: 0.12rem;
    }

    .levelTitle {
      color: #ffffff;
      font-weight: 700;
      font-size: 0.32rem;
      padding-right: 1.08rem;
      text-align: right;
    }

    .levelLook {
      width: max-content;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      padding: 0.05rem 0.09rem;
      cursor: pointer;

      .levelTop {
        color: #cf094b;
        font-size: 0.14rem;
      }

      img {
        width: 0.14rem;
        height: 0.1rem;
        margin-left: 0.06rem;
      }
    }
  }

  .model {
    background: #24292f;
    width: 70%;
    display: flex;

    .modelLeft {
      display: flex;
      align-items: center;
      padding: 0 0 0 0.4rem;
    }

    .modelImg {
      width: 0.6rem;
      height: 0.6rem;
    }

    .modelRight {
      margin-left: 0.12rem;
      padding-right: 0.4rem;
      border-right: 0.01rem solid #54616e;

      .modelTitle {
        color: #fff;
        font-size: 0.36rem;
        font-weight: 700;
      }

      .modelText {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.16rem;
        font-weight: 400;
      }
    }

    .modelLeft:nth-child(3) .modelRight {
      border-right: 0;
    }
  }
}

// 二
.slate {
  .slateTitle {
    color: #131313;
    font-size: 0.4rem;
    font-weight: 900;
    text-align: center;
    margin-top: 1rem;
  }

  span {
    width: 0.56rem;
    height: 0.08rem;
    background: #cf094b;
    margin: 0.12rem auto 0;
    display: block;
  }
}

.generation {
  padding: 1.2rem 2.8rem 0;
  display: flex;
  justify-content: space-between;

  .generLeft {
    width: 6.04rem;

    .generTitle {
      color: #cf094b;
      font-size: 0.24rem;
      font-weight: 700;
    }

    .generText {
      color: #515356;
      font-size: 0.16rem;
      font-weight: 300;
      line-height: 0.26rem;
      text-align: justify;
      margin: 0.16rem 0 0.48rem;
    }

    .generLook {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.24rem;
      height: 0.5rem;
      background: #cf094b;
      cursor: pointer;

      span {
        color: #fff;
        font-size: 0.18rem;
        font-weight: 400;
      }

      img {
        width: 0.08rem;
        height: 0.12rem;
      }
    }
  }

  .generRight {
    width: 6.76rem;
    height: 3.8rem;

    video {
    }
  }
}

// 三
.newBox {
  padding: 1.2rem 2.8rem 0;

  .newTitle {
    color: #131313;
    font-size: 0.4rem;
    font-weight: 900;
  }

  span.newLine {
    display: block;
    width: 0.56rem;
    height: 0.08rem;
    background: #cf094b;
    margin: 0.12rem 0 0.64rem;
  }

  .new {
    display: flex;

    .newLeft {
      .newImg {
        width: 6rem;
        height: 4.8rem;

        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .newRight {
      width: 7.9rem;
      height: 4.81rem;
      overflow: auto;
      padding-right: 0.2rem;
      box-sizing: border-box;
      .newTop {
        width: 100%;
        height: 1.59rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 0.01rem solid #ececec;
        border-bottom: 0.01rem solid #ececec;
        transition: all 0.3s;

        .topLeft {
          padding-left: 0.25rem;

          .day {
            color: #333333;
            font-size: 0.2rem;
            font-weight: 400;
            margin: 0;
            width: 5.4rem;
            line-height: 0.24rem;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 超出几行省略 */
            overflow: hidden;
          }

          .newText {
            margin-top: 0.4rem;
            display: flex;

            span {
              display: block;
              color: #888888;
              font-size: 0.16rem;
              font-weight: 400;
            }

            .time {
              margin-left: 0.12rem;
            }
          }
        }

        .topRight {
          width: 1.2rem;
          height: 1.2rem;
        }

        .topx {
          display: none;
          padding-right: 0.24rem;
        }

        .topRights {
          width: 1.28rem;
          display: flex;
          align-items: center;
          background: #fff;
          justify-content: center;
          padding: 0.12rem 0;
          cursor: pointer;

          .topLook {
            color: #cf094b;
            font-size: 0.16rem;
            font-weight: 400;
          }

          img {
            width: 0.08rem;
            height: 0.12rem;
            margin-left: 0.08rem;
          }
        }
      }

      .newTop:nth-child(2) {
        border-top: 0;
        border-bottom: 0;
      }

      .newTop:hover {
        background: #cf094b;

        .day {
          color: #ffffff;
        }

        .newText span {
          color: rgba(255, 255, 255, 0.8);
        }

        .topRight {
          display: none;
        }

        .topx {
          display: block;
        }
      }
    }
    .newRight::-webkit-scrollbar {
      width: 0.1rem;
      background: #e6e6e6;
    }
    .newRight::-webkit-scrollbar-thumb {
      background: #b0b0b0;
      height: 0.2rem;
      background-color: darkgrey; /* 滑块颜色 */
      border-radius: 0.05rem;
    }
  }
}

// 四
.parity {
  padding: 1.2rem 3.36rem 0;

  .parityTitle {
    color: #131313;
    font-size: 0.4rem;
    font-weight: 900;
    text-align: center;
  }

  .parityLine {
    width: 0.56rem;
    height: 0.08rem;
    background: #cf094b;
    margin: 0.12rem auto 0.64rem;
  }

  .parityImg {
    width: 100%;
    height: 5.2rem;

    img {
      width: 100%;
    }
  }
}

// 五
.productBox {
  padding: 1.2rem 1.79rem 0;

  .productTitle {
    color: #131313;
    font-size: 0.4rem;
    font-weight: 900;
  }

  .productLine {
    width: 0.56rem;
    height: 0.08rem;
    background: #cf094b;
    margin: 0.12rem 0 0.64rem;
  }

  .IntelBox {
    display: flex;
    justify-content: space-between;

    .Intel {
      .intelP {
        position: relative;

        img {
          height: 5.4rem;
          width: 3.06rem;
        }

        .intelA {
          position: absolute;
          top: 0;
        }
      }

      .intelTitle {
        color: #fff;
        font-size: 0.24rem;
        font-weight: 700;
        padding: 0.32rem 0 0.08rem 0.4rem;
      }

      .intelLine {
        width: 1.19rem;
        height: 0.01rem;
        background: rgba(255, 255, 255, 0.4);
        margin: 0 0 0.12rem 0.4rem;
      }

      .intelText {
        color: #ffffff;
        font-size: 0.16rem;
        font-weight: 400;
        padding: 0.2rem 0 0 0.4rem;
        cursor: pointer;
        transition: all 0.3s;
      }

      .intelText:hover {
        color: #cf094b;
      }
    }

    .Intel:nth-child(2) {
      .intelText:nth-child(9) {
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }
}

// 六
.planBox {
  width: 100%;
  height: 93%;
  background-image: url("../assets/homeview/plan.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 0 1.8rem 0.5rem;
  box-sizing: border-box;
  .planTitle {
    color: #ffffff;
    font-size: 0.4rem;
    font-weight: 900;
    padding-top: 0.9rem;
  }

  .planLine {
    width: 0.56rem;
    height: 0.08rem;
    background: #cf094b;
    margin: 0.12rem 0 0.64rem;
  }

  .secPop {
    display: flex;
    flex-wrap: wrap;
  }

  .sector {
    width: 100%;
    height: 5.4rem;
    overflow: auto;
    .Dtrade {
      display: flex;
      flex-wrap: wrap;
    }
    .trade {
      background: #fff;
      width: 14.2%;
      // height: 1.35rem;
      border: 0.5px solid #e8e8e8;
      transition: all 0.3s;
      cursor: pointer;
      box-sizing: border-box;
      position: relative;
      img {
        width: 0.32rem;
        height: 0.3rem;
        margin: 0 auto;
        padding-top: 0.37rem;
      }

      .tradeText {
        color: #333333;
        font-weight: 400;
        font-size: 0.16rem;
        margin-top: 0.16rem;
        text-align: center;
        padding: 0 0.18rem 0.36rem;
      }
      .red {
        // width: 0.89rem;
        padding: 0.07rem 0.09rem;
        // height: 0.26rem;
        background: #cf094b;
        color: #ffffff;
        font-size: 0.12rem;
        position: absolute;
        top: 0;
      }
    }

    .trade:hover {
      background: #eff0f2;
      border: 0.005rem solid #eff0f2;
    }
    .sectorLeft {
      height: 5.4rem;
      width: 20%;
      .sectorTory {
        background: #ffffff;
        border: 0.5px solid #e8e8e8;
        padding: 0.8rem 0.35rem 0.8rem 0.4rem;
        display: flex;
        align-items: baseline;
        justify-content: center;
        transition: all 0.3s;
        height: 1.8rem;
        box-sizing: border-box;

        span {
          display: block;
          color: #333333;
          font-weight: 700;
          font-size: 0.2rem;
          transition: all 0.3s;
        }

        i {
          display: block;
          padding-left: 0.72rem;
          font-size: 0.14rem;
        }
      }

      .sectorTory:hover {
        background: #cf094b;
        border: 0.5px solid #cf094b;

        span {
          color: #fff;
        }

        i {
          color: #fff;
        }
      }
    }

    .sectorRight {
      width: 80%;
      height: 100%;

      .sector {
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        width: 100%;
      }

      .trade {
        background: #fff;
        width: 16.5%;
        height: 1.35rem;
        border: 0.005rem solid #e8e8e8;
        transition: all 0.3s;
        cursor: pointer;
        box-sizing: border-box;

        img {
          width: 0.32rem;
          margin: 0 auto;
          padding-top: 0.37rem;
        }

        .tradeText {
          color: #333333;
          font-weight: 400;
          font-size: 0.16rem;
          margin-top: 0.18rem;
          text-align: center;
          padding-bottom: 0.35rem;
        }
      }

      .trade:hover {
        background: #eff0f2;
        border: 0.005rem solid #eff0f2;
      }
    }
  }
}

// 七
.surveyBox {
  padding: 0 1.8rem 0;

  .surveyTitle {
    color: #131313;
    font-size: 0.4rem;
    font-weight: 900;
    padding-top: 0.9rem;
  }

  .surveyLine {
    width: 0.56rem;
    height: 0.08rem;
    background: #cf094b;
    margin: 0.12rem 0 0.64rem;
  }

  .survey {
    display: flex;
    flex-wrap: wrap;

    .surveyImg {
      width: 2.2rem;
      height: 1.4rem;
      img {
        height: 100%;
      }
    }
  }
}
</style>
